"use strict";
/**
 * @fileoverview gRPC-Web generated client stub for loopup.ctgateway.v2
 * @enhanceable
 * @public
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberManagementAPIClient = void 0;
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck
var grpcWeb = require("grpc-web");
var v2_number_management_api_pb = require("../v2/number_management_api_pb");
var NumberManagementAPIClient = /** @class */ (function () {
    function NumberManagementAPIClient(hostname, credentials, options) {
        this.methodInfoListCustomerDDIs = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.NumberManagementAPI/ListCustomerDDIs', grpcWeb.MethodType.UNARY, v2_number_management_api_pb.ListCustomerDDIsRequest, v2_number_management_api_pb.ListCustomerDDIsResponse, function (request) {
            return request.serializeBinary();
        }, v2_number_management_api_pb.ListCustomerDDIsResponse.deserializeBinary);
        this.methodInfoGetDDIFilters = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.NumberManagementAPI/GetDDIFilters', grpcWeb.MethodType.UNARY, v2_number_management_api_pb.GetDDIFiltersRequest, v2_number_management_api_pb.GetDDIFiltersResponse, function (request) {
            return request.serializeBinary();
        }, v2_number_management_api_pb.GetDDIFiltersResponse.deserializeBinary);
        this.methodInfoAssignDDIToServiceUser = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.NumberManagementAPI/AssignDDIToServiceUser', grpcWeb.MethodType.UNARY, v2_number_management_api_pb.AssignDDIToServiceUserRequest, v2_number_management_api_pb.AssignDDIToServiceUserResponse, function (request) {
            return request.serializeBinary();
        }, v2_number_management_api_pb.AssignDDIToServiceUserResponse.deserializeBinary);
        this.methodInfoRevokeDDIFromServiceUser = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.NumberManagementAPI/RevokeDDIFromServiceUser', grpcWeb.MethodType.UNARY, v2_number_management_api_pb.RevokeDDIFromServiceUserRequest, v2_number_management_api_pb.RevokeDDIFromServiceUserResponse, function (request) {
            return request.serializeBinary();
        }, v2_number_management_api_pb.RevokeDDIFromServiceUserResponse.deserializeBinary);
        this.methodInfoGetNumber = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.NumberManagementAPI/GetNumber', grpcWeb.MethodType.UNARY, v2_number_management_api_pb.GetNumberRequest, v2_number_management_api_pb.GetNumberResponse, function (request) {
            return request.serializeBinary();
        }, v2_number_management_api_pb.GetNumberResponse.deserializeBinary);
        this.methodInfoGetNumbers = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.NumberManagementAPI/GetNumbers', grpcWeb.MethodType.UNARY, v2_number_management_api_pb.GetNumbersRequest, v2_number_management_api_pb.GetNumbersResponse, function (request) {
            return request.serializeBinary();
        }, v2_number_management_api_pb.GetNumbersResponse.deserializeBinary);
        this.methodInfoCreateNumber = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.NumberManagementAPI/CreateNumber', grpcWeb.MethodType.UNARY, v2_number_management_api_pb.CreateNumberRequest, v2_number_management_api_pb.CreateNumberResponse, function (request) {
            return request.serializeBinary();
        }, v2_number_management_api_pb.CreateNumberResponse.deserializeBinary);
        this.methodInfoUpdateNumber = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.NumberManagementAPI/UpdateNumber', grpcWeb.MethodType.UNARY, v2_number_management_api_pb.UpdateNumberRequest, v2_number_management_api_pb.UpdateNumberResponse, function (request) {
            return request.serializeBinary();
        }, v2_number_management_api_pb.UpdateNumberResponse.deserializeBinary);
        this.methodInfoGetInProgressNumberChanges = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.NumberManagementAPI/GetInProgressNumberChanges', grpcWeb.MethodType.SERVER_STREAMING, v2_number_management_api_pb.GetInProgressNumberChangesRequest, v2_number_management_api_pb.GetInProgressNumberChangesResponse, function (request) {
            return request.serializeBinary();
        }, v2_number_management_api_pb.GetInProgressNumberChangesResponse.deserializeBinary);
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname;
        this.credentials_ = credentials;
        this.options_ = options;
    }
    NumberManagementAPIClient.prototype.listCustomerDDIs = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.NumberManagementAPI/ListCustomerDDIs', request, metadata || {}, this.methodInfoListCustomerDDIs, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.NumberManagementAPI/ListCustomerDDIs', request, metadata || {}, this.methodInfoListCustomerDDIs);
    };
    NumberManagementAPIClient.prototype.getDDIFilters = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.NumberManagementAPI/GetDDIFilters', request, metadata || {}, this.methodInfoGetDDIFilters, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.NumberManagementAPI/GetDDIFilters', request, metadata || {}, this.methodInfoGetDDIFilters);
    };
    NumberManagementAPIClient.prototype.assignDDIToServiceUser = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.NumberManagementAPI/AssignDDIToServiceUser', request, metadata || {}, this.methodInfoAssignDDIToServiceUser, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.NumberManagementAPI/AssignDDIToServiceUser', request, metadata || {}, this.methodInfoAssignDDIToServiceUser);
    };
    NumberManagementAPIClient.prototype.revokeDDIFromServiceUser = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.NumberManagementAPI/RevokeDDIFromServiceUser', request, metadata || {}, this.methodInfoRevokeDDIFromServiceUser, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.NumberManagementAPI/RevokeDDIFromServiceUser', request, metadata || {}, this.methodInfoRevokeDDIFromServiceUser);
    };
    NumberManagementAPIClient.prototype.getNumber = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.NumberManagementAPI/GetNumber', request, metadata || {}, this.methodInfoGetNumber, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.NumberManagementAPI/GetNumber', request, metadata || {}, this.methodInfoGetNumber);
    };
    NumberManagementAPIClient.prototype.getNumbers = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.NumberManagementAPI/GetNumbers', request, metadata || {}, this.methodInfoGetNumbers, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.NumberManagementAPI/GetNumbers', request, metadata || {}, this.methodInfoGetNumbers);
    };
    NumberManagementAPIClient.prototype.createNumber = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.NumberManagementAPI/CreateNumber', request, metadata || {}, this.methodInfoCreateNumber, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.NumberManagementAPI/CreateNumber', request, metadata || {}, this.methodInfoCreateNumber);
    };
    NumberManagementAPIClient.prototype.updateNumber = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.NumberManagementAPI/UpdateNumber', request, metadata || {}, this.methodInfoUpdateNumber, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.NumberManagementAPI/UpdateNumber', request, metadata || {}, this.methodInfoUpdateNumber);
    };
    NumberManagementAPIClient.prototype.getInProgressNumberChanges = function (request, metadata) {
        return this.client_.serverStreaming(this.hostname_ +
            '/loopup.ctgateway.v2.NumberManagementAPI/GetInProgressNumberChanges', request, metadata || {}, this.methodInfoGetInProgressNumberChanges);
    };
    return NumberManagementAPIClient;
}());
exports.NumberManagementAPIClient = NumberManagementAPIClient;
